<div class="row no-gutters" *ngIf="participant">
  <div class="col-sm-12">
    <div class="row no-gutters" *ngIf="withTitle">
      <div class="col-sm-12">
        <mat-radio-group id="{{idPrefix}}participant.gender"
                         [(ngModel)]="participantTitle"
                         (change)="patchAndUpdate('title')"
                         [disabled]="disabled">
          <mat-radio-button id="{{idPrefix}}participant.gender.M" labelPosition="after" value="M" style="margin-right: 10px; margin-top: 10px;">{{ participant.trans.mr | translate }}</mat-radio-button>
          <mat-radio-button id="{{idPrefix}}participant.gender.F" labelPosition="after" value="F" style="margin-right: 10px;">{{ participant.trans.ms | translate }}</mat-radio-button>
          <mat-radio-button id="{{idPrefix}}participant.gender.NONE" labelPosition="after" value="">{{ participant.trans.not_specified | translate }}</mat-radio-button>
        </mat-radio-group>

        <button mat-icon-button
                style="float: right;"
                id="{{idPrefix}}btn.search"
                (click)="searchBtnClicked()"
                [disabled]="disabled"
                *ngIf="withSearch">
          <mat-icon class="dr-material-icon" aria-label="Search">search</mat-icon>
        </button>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withName">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ typeForLabel }}{{ participant.trans.name1 | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.trans.name1}}"
                 type="text" matInput
                 [(ngModel)]="participant.name1"
                 (blur)="patchAndUpdate('name1')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withMultiNames">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ typeForLabel }}{{ participant.trans.name2 | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.trans.name2}}"
                 type="text" matInput
                 [(ngModel)]="participant.name2"
                 (blur)="patchAndUpdate('name2')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withMultiNames">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ typeForLabel }}{{ participant.trans.name3 | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.trans.name3}}"
                 type="text" matInput
                 [(ngModel)]="participant.name3"
                 (blur)="patchAndUpdate('name3')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withAddress">
      <div class="col-sm-8" style="padding-right: 25px;">
        <mat-form-field class="full-width">
          <mat-label>{{ participant.address.trans.street | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.address.trans.street}}"
                 type="text" matInput
                 [(ngModel)]="participant.address.street"
                 (blur)="patchAndUpdate('address.street')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>

      <div class="col-sm-4">
        <mat-form-field class="full-width">
          <mat-label>{{ participant.address.trans.number | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.address.trans.number}}"
                 type="text" matInput
                 [(ngModel)]="participant.address.number"
                 (blur)="patchAndUpdate('address.number')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withAddress">
      <div class="col-sm-4" style="padding-right: 25px;">
        <mat-form-field class="full-width">
          <mat-label>{{ participant.address.trans.postalcode | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.address.trans.postalcode}}"
                 type="text" matInput
                 [(ngModel)]="participant.address.postalcode"
                 (blur)="patchAndUpdate('address.postalcode')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>

      <div class="col-sm-8">
        <mat-form-field class="full-width">
          <mat-label>{{ participant.address.trans.city | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.address.trans.city}}"
                 type="text" matInput
                 [(ngModel)]="participant.address.city"
                 (blur)="patchAndUpdate('address.city')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>
    
    <div class="row no-gutters" *ngIf="withCountry">
      <div class="col-sm-12">
        <country-select class="full-width"
                        [idPrefix]="idPrefix"
                        [idSuffix]="'.address.country'"
                        [selectedId]="this.participant.address.getCountryPropertyCode"
                        [options]="countrySelectOptions"
                        (multiUpdated)="patchOpDataArray($event)"
                        [disabled]="disabled">
        </country-select>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withPhone">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ typeForLabel }}{{ participant.address.trans.phone | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.address.trans.phone}}"
                 type="text" matInput
                 [(ngModel)]="participant.address.phone"
                 (blur)="patchAndUpdate('address.phone')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withPhone2">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ typeForLabel }}{{ participant.address.trans.phone2 | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.address.trans.phone2}}"
                 type="text" matInput
                 [(ngModel)]="participant.address.phone2"
                 (blur)="patchAndUpdate('address.phone2')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withFax">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ typeForLabel }}{{ participant.address.trans.fax | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.address.trans.fax}}"
                 type="text" matInput
                 [(ngModel)]="participant.address.fax"
                 (blur)="patchAndUpdate('address.fax')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withEmail">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ typeForLabel }}{{ participant.address.trans.email | translate }}</mat-label>
          <input id="{{idPrefix}}{{participant.address.trans.email}}"
                 type="email" matInput
                 [(ngModel)]="participant.address.email"
                 (blur)="patchAndUpdate('address.email')"
                 [disabled]="disabled">
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters" *ngIf="withComment">
      <div class="col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>{{ typeForLabel }}{{ participant.trans.comment | translate }}</mat-label>
          <textarea id="{{idPrefix}}{{participant.trans.comment}}"
                    matInput
                    rows="6"
                    [(ngModel)]="participant.comment"
                    (blur)="patchAndUpdate('comment')"
                    [disabled]="disabled">
          </textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
